export default __webpack_public_path__ + "static/media/groupPeople.afd88a21.svg";